import React from "react";
import Link from 'components/Models/Link/Link';
import AlvComponentModel from 'components/Models/AlvComponent/AlvComponent';
import AlvStockPrice from 'components/AlvStockPrice';
import Icon from 'components/Icon';
import PropTypes from 'prop-types';

import "./AlvStockPriceTeaser.scss";

const AlvStockPriceTeaser = ({ heading, goToStockLink, language }) => {
    const WrapperTag = goToStockLink ? 'a' : 'div';

    const wrapperTagProps = {
        ...(goToStockLink && {
            href: goToStockLink.url,
            target: goToStockLink.openInNewWindow ? '_blank' : null,
            className: "alv-stock-price-teaser__link"
        }),
    };

    return (
        <div className="alv-stock-price-teaser">
            <WrapperTag {...wrapperTagProps}>
                <div className="alv-stock-price-teaser__card">
                    <div className="alv-stock-price-teaser__card-content">
                        <AlvStockPrice language={language} />
                        {goToStockLink && (
                            <div className="alv-stock-price-teaser__link-holder">
                                <span className="alv-stock-price-teaser__link-text">
                                    <span>{goToStockLink.linkText}</span>
                                    <Icon icon="arrow-line-right" className="alv-stock-price-teaser__link-icon" />
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                {heading && (
                    <div className="alv-stock-price-teaser__heading-holder hidden-mobile">
                        <h3 className="alv-stock-price-teaser__heading">{heading}</h3>
                    </div>
                )}
            </WrapperTag>
        </div>
    );

};

AlvStockPriceTeaser.propTypes = Object.assign({}, AlvComponentModel.propTypes, {
    heading: PropTypes.string,
    goToStockLink: PropTypes.shape(Link.propTypes),
});

export default AlvStockPriceTeaser;


// WEBPACK FOOTER //
// ./src/components/AlvStockPriceTeaser/AlvStockPriceTeaser.jsx